export class AssinarRequest {
  empresa: number;
  email: string;
  plano: number;
}
